import { useRecoilState, useRecoilValue } from 'recoil';
import {
    aBottomImageIndex,
    aCreateOrUpdateWidget,
    aCurrentWidgetIndex,
    aDisplayCreateWidgetModal,
    aEditedWidget,
    aIsBottomImageExpanded,
    aIsMeetingCornerSettingLoadedFromDB,
    aSelectedArtwork,
    aShowPersonalMeetingCorner,
    aTopImageIndex,
    aTypeOfPersonalRoomTable,
    aWidgetsList
} from './atoms';
import { NGASearchResult } from '../components/Widgets/ArtGallery/ArtGallery.state';
import { IWidget } from '../components/Widgets/type';
import { sIsUserAloneInOwnPersonalRoom, sMeetingCornerSetting } from './selectors';

export const useSelectedArtwork = (): [NGASearchResult | null, (artwork: NGASearchResult | null) => void] => {
    return useRecoilState(aSelectedArtwork);
};

export const useCreateOrUpdateWidget = (): ['create' | 'update', (widget: 'create' | 'update') => void] => {
    return useRecoilState(aCreateOrUpdateWidget);
};

export const useEditedWidget = (): [IWidget | null, (widget: IWidget | null) => void] => {
    return useRecoilState(aEditedWidget);
};

//! remove later(only being used in previous-RoomCallController.view.tsx)
export const useShowPersonalMeetingCorner = (): any => {
    return useRecoilState(aShowPersonalMeetingCorner);
};

export const useTypeOfPersonalRoomTable = (): ['desk' | 'meeting-table', (table: 'desk' | 'meeting-table') => void] => {
    return useRecoilState(aTypeOfPersonalRoomTable);
};

export const useDisplayCreateWidgetModal = (): any => {
    return useRecoilState(aDisplayCreateWidgetModal);
};

export const useTopImageIndex = (): [number, (index: number) => void] => {
    return useRecoilState(aTopImageIndex);
};

export const useBottomImageIndex = (): [number, (index: number) => void] => {
    return useRecoilState(aBottomImageIndex);
};

export const useIsUserAloneInOwnPersonalRoom = (): boolean => {
    return useRecoilValue(sIsUserAloneInOwnPersonalRoom);
};

export const useWidgetsList = (): [IWidget[], (widgets: IWidget[]) => void] => {
    return useRecoilState(aWidgetsList);
};

export const useCurrentWidgetIndex = (): [number, (index: number) => void] => {
    return useRecoilState(aCurrentWidgetIndex);
};

export const useMeetingCornerSetting = (): { widgets: IWidget[]; topImageIndex: number; bottomImageIndex: number } => {
    return useRecoilValue(sMeetingCornerSetting);
};

export const useIsBottomImageExpanded = (): [boolean, (expanded: boolean) => void] => {
    return useRecoilState(aIsBottomImageExpanded);
};

export const useIsMeetingCornerSettingLoadedFromDB = (): [boolean, (loaded: boolean) => void] => {
    return useRecoilState(aIsMeetingCornerSettingLoadedFromDB);
};
